<template>
  <div>
    <pcHeaders></pcHeaders>

    <div class="cen">
      <div class="w">
        <div class="headBox">
          <div class="leftBox">
            <img v-if=" classInfo.classImage !== null"
                 :src="classInfo.classImage"
                 alt="安全生产学习平台"
                 :title="classInfo.className"
                 @error="handleError" />
            <div v-else
                 style="position: relative; display: flex; justify-content: center; align-items: center; width: 320px; height: 256px">
              <img style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
                   src="../../assets/indexImg/noimg.png"
                   alt="111" />
              <div style="
                  position: relative;
                  z-index: 11;
                  font-size: 15px;
                  font-family: kaiti;
                  text-align: center;
                  padding: 0 10px;
                  font-weight: bold;
                  color: #355fd9;
                ">

                {{ classInfo.className }}
              </div>
            </div>
          </div>
          <div class="rightBox">
            <div style="
                font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
                font-weight: bold;
                font-size: 20px;
                color: #333333;
                width: 900px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: pointer;
              ">
              {{ classInfo.className }}
            </div>

            <div class="mt10 text_1">
              <span>{{ classInfo.classCodeName }}</span>
              <span>{{ classInfo.classCredithour }}学时</span>
              <!-- <span>继续教育</span> -->
            </div>
            <div class="mt10 text_2">
              培训方式：{{ classInfo.classType == '01' ? '在线' : classInfo.classType == '02' ? '面授' : '混合' }}
            </div>
            <div class="text_2">上课时间: {{ classInfo.classStarttime }} - {{ classInfo.classEndtime }}</div>
            <div class="text_2">报名时间: {{ classInfo.classEnrolStarttime }} - {{ classInfo.classEnrolEndtime }}</div>
            <div class="text_3"
                 v-if="classInfo.isClassApply=='02'">价格: <span style="color: #ff6632; font-size: 22px; font-weight: bold">￥{{ Number(classInfo.classPrice).toFixed(1)}}</span></div>
            <div class="text_3"
                 v-if="priceShow">价格: <span style="color: #ff6632; font-size: 22px; font-weight: bold">￥{{classInfo.creditPrice}}</span><span
                    style="color: #ff6632; font-size: 18px; font-weight: bold">/学时</span></div>

            <div class="box_1"
                 v-if="classInfo.isBuy=='01'||!classInfo.isBuy&&classInfo.classEnrolStatus=='02'">
              <div class="goumBtn"
                   style="background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%); margin-right: 24px"
                   @click="tableHandel()">
                免费试听
              </div>

              <div class="goumBtn"
                   style="background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%)"
                   @click="purchase(classInfo.classId)">
                立即购买
              </div>
            </div>
          </div>
          <div class="hot">火热</div>
        </div>
        <!-- 课程介绍 -->
        <div class="courseInto"
             id="courseInto">
          <div class="titleBox">
            <div class="title_1">课程介绍</div>
            <div class="title_2">COURSE DESCRIPTION</div>
          </div>
          <div style="margin-top: 30px; display: flex">
            <div class="croBox"
                 style="margin-right: 20px"
                 v-if="classInfo.classDescTitle1&&classInfo.classDescContent1">
              <div class="text_4">{{classInfo.classDescTitle1}}</div>
              <div class="content1">
                {{ classInfo.classDescContent1 }}
              </div>
            </div>
            <div class="croBox"
                 v-if="classInfo.classDescTitle2&&classInfo.classDescContent2">
              <div class="text_4">{{classInfo.classDescTitle2}}</div>
              <div class="content1">
                {{ classInfo.classDescContent2 }}
              </div>
            </div>
          </div>
          <div class="section_1">
            <div class="box_2"
                 v-if="classInfo.classDescTitle3&&classInfo.classDescContent3">
              <div class="text_5">{{classInfo.classDescTitle3}}</div>
              <div class="text_6">
                {{ classInfo.classDescContent3 }}
              </div>
            </div>
            <div style="width: 30px; height: 60px"
                 v-if="classInfo.classDescTitle3&&classInfo.classDescContent3">
              <img style="width: 30px; height: 60px"
                   src="../../assets/images/jiantou.png"
                   alt="" />
            </div>

            <div class="box_2"
                 v-if="classInfo.classDescTitle4&&classInfo.classDescContent4">
              <div class="text_5">{{classInfo.classDescTitle4}}</div>
              <div class="text_6">
                {{ classInfo.classDescContent4 }}
              </div>
            </div>

            <div style="width: 30px; height: 60px"
                 v-if="classInfo.classDescTitle4&&classInfo.classDescContent4">
              <img style="width: 30px; height: 60px"
                   src="../../assets/images/jiantou.png"
                   alt="" />
            </div>

            <div class="box_2"
                 v-if="classInfo.classDescTitle5&&classInfo.classDescContent5">
              <div class="text_5">{{classInfo.classDescTitle5}}</div>
              <div class="text_6">
                {{ classInfo.classDescContent5 }}
              </div>
            </div>

            <div style="width: 30px; height: 60px"
                 v-if="classInfo.classDescTitle5&&classInfo.classDescContent5">
              <img style="width: 30px; height: 60px"
                   src="../../assets/images/jiantou.png"
                   alt="" />
            </div>

            <div class="box_2"
                 v-if="classInfo.classDescTitle6&&classInfo.classDescContent6">
              <div class="text_5"> {{ classInfo.classDescTitle6 }}</div>
              <div class="text_6">
                {{ classInfo.classDescContent6 }}
              </div>
            </div>
          </div>
        </div>
        <!-- 课程目录 -->
        <div class="contents"
             id="contents">
          <div class="titleBox1"
               style="margin-bottom: 47px;">
            <div class="title_1">课程目录</div>
            <div class="title_2">COURSE CATALOG</div>
          </div>
          <div v-if="courseList.length>0">
            <div style="margin-top: 10px"
                 v-for="(item1,index) in courseList"
                 :key="index">
              <!-- 展开前 -->
              <div class="catalog"
                   v-show="!isExpanded(index)"
                   @click="toggleExpand(index)">
                <div class="text_10">{{item1.cname}}</div>
                <div class="text_11">合计{{item1.cwSize}}章<img src="../../assets/images/right.png"
                       alt=""
                       style="width: 14px; height: 14px" /></div>
              </div>
              <!-- 展开后 -->
              <div class="catalog_1"
                   v-show="isExpanded(index)">
                <div style="display: flex; justify-content: space-between"
                     @click="toggleExpand(index)">
                  <div class="text_12">{{item1.cname}}</div>
                  <div class="text_13">合计{{item1.cwSize}}章<img src="../../assets/images/bottom.png"
                         alt=""
                         style="width: 14px; height: 14px" /></div>
                </div>
                <div v-for="(v,index1) in item1.cwList"
                     :key="v.id">
                  <div class="chapter"
                       v-for="h in v.chapterList"
                       :key="h.id">
                    <div class="chapter_1">
                      <div class="text_14">第{{index1+1}}章 :{{h.chapterTitle}}</div>
                      <div class="text_15">总时长 {{h.period}}</div>
                    </div>
                    <div class="chapter_2"
                         @click="watch(item1.id)"
                         v-if="index1==0">试看</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex;justify-content: center;font-size: 20px;height: 100px; margin-top: 100px;"
               v-if="this.courseList.length==0||this.courseList==null">暂无课程~</div>
        </div>
        <!-- 讲师介绍 -->
        <div class="tearchInfo"
             id="tearchInfo">
          <div class="titleBox2">
            <div class="title_1">讲师介绍</div>
            <div class="title_2">LECTURER INTRODUCTION</div>
          </div>
          <div style="display: flex;"
               v-if="classInfo.teacherRealName">
            <div class="tearch_1">
              <div style="display: flex; justify-content: space-between">
                <div style="width: 865px">
                  <div class="te_name"> {{ classInfo.teacherRealName }}
                  </div>
                  <div class="present">
                    <div class="present_1"
                         v-if="classInfo.position ">{{ classInfo.position }}</div>
                    <!-- <div class="present_2">{{ classInfo.teacherRealName }}</div> -->
                  </div>
                  <div class="te_info"
                       v-html="classInfo.teacherDesc">

                  </div>
                </div>
                <!-- 照片 -->
                <div style="width: 199px; height: 269px"
                     v-if="classInfo.teacherImage"><img style="width: 199px;
    height: 269px;"
                       :src="classInfo.teacherImage"
                       alt=""
                       :title="classInfo.teacherRealName "></div>
              </div>
            </div>

          </div>
          <div style="display: flex;justify-content: center;font-size: 20px; margin-top: 100px;height: 100px;"
               v-else>暂无讲师~</div>

        </div>
        <!-- 就业分析 -->
        <div class="analysis"
             id="analysis">
          <div class="titleBox2">
            <div class="title_1">就业分析</div>
            <div class="title_2">EMPLOYMENT ANALYSIS</div>
          </div>
          <div style="display: flex; margin-top: 23px; flex-wrap: wrap;">
            <div class="ana_1"
                 style="margin-right: 30px;"
                 v-if="classInfo.employAnalysisTitle1!=''&&classInfo.employAnalysisContent1!=''">
              <div class="ana_icon"><img src="../../assets/images/jiuye1.png"
                     alt="" /> {{classInfo.employAnalysisTitle1}}</div>
              <div class="ana_text">
                {{ classInfo.employAnalysisContent1 }}
              </div>
            </div>
            <div class="ana_1"
                 style="margin-right: 30px;"
                 v-if="classInfo.employAnalysisTitle2!=''&&classInfo.employAnalysisContent2!=''">
              <div class="ana_icon"><img src="../../assets/images/jiuye2.png"
                     alt="" /> {{classInfo.employAnalysisTitle2}}</div>
              <div class="ana_text">
                {{ classInfo.employAnalysisContent2 }}

              </div>
            </div>
            <div class="ana_1"
                 v-if="classInfo.employAnalysisTitle3!=''&&classInfo.employAnalysisContent3!=''">
              <div class="ana_icon"><img src="../../assets/images/jiuye3.png"
                     alt="" /> {{classInfo.employAnalysisTitle3}}</div>
              <div class="ana_text">
                {{ classInfo.employAnalysisContent3 }}

              </div>
            </div>
            <div class="ana_1"
                 style="margin-right: 30px;"
                 v-if="classInfo.employAnalysisTitle4!=''&&classInfo.employAnalysisContent4!=''">
              <div class="ana_icon"><img src="../../assets/images/jiuye4.png"
                     alt="" /> {{classInfo.employAnalysisTitle4}}</div>
              <div class="ana_text">
                {{ classInfo.employAnalysisContent4 }}

              </div>
            </div>
            <div class="ana_1"
                 style="margin-right: 30px;"
                 v-if="classInfo.employAnalysisTitle5!=''&&classInfo.employAnalysisContent5!=''">
              <div class="ana_icon"><img src="../../assets/images/jiuye5.png"
                     alt="" /> {{classInfo.employAnalysisTitle5}}</div>
              <div class="ana_text">
                {{ classInfo.employAnalysisContent5 }}

              </div>
            </div>
            <div class="ana_1"
                 v-if="classInfo.employAnalysisTitle6!=''&&classInfo.employAnalysisContent6!=''">
              <div class="ana_icon"><img src="../../assets/images/jiuye6.png"
                     alt="" /> {{classInfo.employAnalysisTitle6}}</div>
              <div class="ana_text">
                {{ classInfo.employAnalysisContent6 }}

              </div>
            </div>
          </div>
        </div>
        <!-- 班级优势 -->
        <div class="advantages"
             id="advantages">

          <div class="titleBox2">
            <div class="title_1">班级优势</div>
            <div class="title_2">CLASS ADVANTAGES</div>
          </div>
          <div style="display: flex;">
            <div style="width: 490px;">
              <div style="display: flex; justify-content: center; margin-top: 47px; margin-left: 73px">
                <div class="adva_1">
                  <div class="adva_2">线上教学</div>
                  <div class="adva_3">学习时间空间不受限，可根据自身实际灵活学习。</div>
                </div>
              </div>
              <div style="display: flex; justify-content: center; margin-top: 47px; margin-left: 73px">
                <div class="adva_4">
                  <div class="adva_5">多模式讲师</div>
                  <div class="adva_6">采用多重讲授模式，帮助学员扩充知识，举一反三。</div>
                </div>
              </div>
              <div style="display: flex; justify-content: center; margin-top: 47px; margin-bottom: 44px; margin-left: 73px">
                <div class="adva_7">
                  <div class="adva_8">实操技能</div>
                  <div class="adva_9">结合实际工作需要，定向培养建模组价实用性技能。</div>
                </div>
              </div>
            </div>
            <div style="width: 490px;margin-left: 50px;">
              <div style="display: flex; justify-content: center; margin-top: 47px; margin-left: 73px">
                <div class="adva_1">
                  <div class="adva_12">高性价比</div>
                  <div class="adva_13">省场地交通成本，享低价优质教育资源</div>
                </div>
              </div>
              <div style="display: flex; justify-content: center; margin-top: 47px; margin-left: 73px">
                <div class="adva_4">
                  <div class="adva_15">优质服务</div>
                  <div class="adva_16">24 小时客服在线，及时响应解学习之忧</div>
                </div>
              </div>
              <div style="display: flex; justify-content: center; margin-top: 47px; margin-bottom: 44px; margin-left: 73px">
                <div class="adva_7">
                  <div class="adva_18">个性化学习</div>
                  <div class="adva_19">智能算法大数据，精准推课提学习效果</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 学员评价 -->
        <div class="evaluation"
             id="evaluation">
          <div class="titleBox2">
            <div class="title_1">学员评价</div>
            <div class="title_2">STUDENT EVALUATION</div>
          </div>
          <div v-if="evaluateList[0] !== ''">
            <div class="student"
                 v-for="(item) in evaluateList"
                 :key="item.id">
              <div style="display: flex; justify-content: space-between; align-items: center">
                <div class="avater">
                  <img :src="item.userPhoto"
                       alt="" />
                  <div class="stu_name">
                    <div>{{item.userName}}</div>
                    <div class="phone">{{item.mobile}}</div>
                  </div>
                </div>
                <div class="time_1">{{item.createTime}}</div>
              </div>
              <div class="evaluate">
                {{ item.content }}
              </div>
            </div>
          </div>
          <div style="    margin-bottom: 100px;
    margin-top: 100px;
    text-align: center;
    font-size: 20px;
    width: 100%;"
               v-if="this.evaluateList.length==0||this.evaluateList==null">暂无评价~</div>
        </div>
        <!-- 购买指南 -->
        <div class="guide"
             id="guide">
          <div class="titleBox2">
            <div class="title_1">购买指南</div>
            <div class="title_2">BUYING GUIDE</div>
          </div>
          <div class="buy_1"
               style="margin-top: 47px;">
            <!-- <div class="buy_btn">课程有效期</div>
            <div class="buy_info">
              ①365天:该产品课程有效期为自购课之日起，满365天(自然日)为止截止。<br>
              ②课程有效期过后，课程/资料(含已下载)将失效，请您按时进行课程学习。
            </div> -->
          </div>
          <div class="buy_1">
            <div class="buy_btn">支付方式</div>
            <div class="buy_info">
              支持微信、支付宝在线支付和银行对公转账汇款。
            </div>
          </div>
          <div class="buy_1">
            <div class="buy_btn">联系电话</div>
            <div class="buy_info">
              客服电话400-8816-822（周一至周五8:30-12:00/14:00-17:30）
            </div>
          </div>
          <div class="buy_1">
            <div class="buy_btn">版权提醒</div>
            <div class="buy_info">
              ①平台官网/APP所有课程(包括:会员功能/题库内容/其他产品)著作权均为公司所有。</br>
              ②平台账号仅限用户本人使用，请您妥善保护自己的平台账号，凡是倒卖账号、未经授权对平台任何课程进行录播并进行销售或将平台课程用于其他商业目的的行为，一经发现，平台将有权进行封号处理。

            </div>
          </div>
        </div>
      </div>
    </div>

    <pcBottom></pcBottom>
    <flotRight />
    <courseNav />
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import { getClassDetailByPx } from '@/api/courseSelection.js';
import flotRight from '@/views/component/flotRight.vue';
import courseNav from '@/views/component/courseNav.vue';
import { toGeneratePxOrder } from '@/api/pay.js';
import { toGenerateOrder } from '@/api/pay.js';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    flotRight,
    courseNav
  },
  metaInfo() {
    return {
      title: this.title + '安全生产学习平台',
      meta: [
        {
          charset: 'utf-8'
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
        }
      ]
    };
  },
  data() {
    // 这里存放数据
    return {
      classId: '',
      classInfo: {}, //班级数据
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      activeIndex: null,
      recommendEmpty: false,
      imgShow: false,
      priceShow: false,
      isZypx: '', //是否是职业培训
      expandedStates: [], // 用于存储每个课程项的展开状态
      courseList: [], //课程列表
      evaluateList: [], //评价列表
      // dialogVisible: false,
      defaultImageUrl: require('../../assets/images/noimg.png'),
      rule: {}, //考试规则
      title: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    handleError(event) {
      event.target.src = this.defaultImageUrl;
    },
    //购买
    purchase(item) {
      //非整体报名
      console.log(item, '888');
      toGenerateOrder({ classIds: item.id, toGenerateOrder: '01' }).then(res => {
        console.log(res,'oooo');
        
        if (res) {
          //生成订单成功
          if (res.data.data.code == '1') {
            this.$router.push({
              path: '/toPayOrder',
              query: {
                orderId: res.data.data.orderId
              }
            });
          }else if(res.data.data.code == '10'){
            //0元订单
            this.$router.push({
              path: '/paySuccess',
              query: {
                orderId: res.data.data.orderId
              }
            });
          }else if(res.data.data.code != '1' && res.data.data.code != '10'){
             this.$message({
                message: 'res.data.data.msg',
              });
          }
        }
      });
    },
    //试听
    tableHandel() {
      // document.getElementById('contents').scrollIntoView({ behavior: 'smooth' });
      // this.$set(this.expandedStates, 0, true);
      // this.$set(this.expandedStates, 0, true);
      
      this.watch(this.courseList[0].cwList[0].courseId)
    },
    //跳转试看页面
    watch(item) {
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: item
        }
      });
    },
    // 课程展开关闭
    isExpanded(index) {
      return this.expandedStates[index];
    },
    toggleExpand(index) {
      this.$set(this.expandedStates, index, !this.expandedStates[index]);
    },
    getClassDetailByPx() {
      getClassDetailByPx({ classId: this.queryParams.classId }).then(res => {
        console.log(res.data.data, 'kkk');

        this.classInfo = res.data.data;
        this.title = this.classInfo.className;
        this.isZypx = this.classInfo.isZypx;
        if (this.classInfo.classCourseList !== null) {
          this.courseList = this.classInfo.classCourseList;
        }
        this.evaluateList = this.classInfo.evaluateList.rows;
        if (this.classInfo.classImage == '') {
          this.imgShow = true;
        }

        if (this.classInfo.isClassApply == '01' || this.classInfo.isClassApply == '' || this.classInfo.isClassApply == null) {
          this.priceShow = true;
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.queryParams.classId = this.$route.query.classId;
    this.getClassDetailByPx();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.scrollTo({ top: 0 });
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.title_1 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 22px;
  color: #333333;
  width: 100%;
  text-align: center;
}

.title_2 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 26px;
  color: rgba(51, 51, 51, 0.05);
}

.cen {
  font-family: Regular;
  display: flex;
  justify-content: center;
  padding-bottom: 100px;
  background: #f6f9fc;

  .w {
    width: 1400px;
    padding-top: 30px;
    background: #f6f9fc;

    .headBox {
      position: relative;
      width: 1400px;
      padding: 30px;
      background: #ffffff;
      box-shadow: 0px 2px 15px 0px rgba(138, 138, 138, 0.08), inset 0px 20px 50px 0px #f0f3f9;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #ffffff;
      display: flex;

      .leftBox {
        width: 320px;
        height: 256px;
        border-radius: 8px;

        img {
          width: 320px;
          height: 256px;
          border-radius: 8px;
        }
      }

      .rightBox {
        margin-left: 25px;
        font-size: 12px;

        .mt10 {
          margin-top: 10px;
        }

        .text_1 {
          width: 100%;
          display: flex;

          span {
            margin-right: 12px;
            display: inline-block;
            padding: 4px 12px;
            height: 28px;
            line-height: 20px;
            background: rgba(64, 118, 246, 0.1);
            border-radius: 2px 2px 2px 2px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #4076f6;
          }
        }

        .text_2 {
          width: 800px;
          height: 20px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-top: 6px;
          cursor: pointer;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #656e7e;
        }

        .text_3 {
          width: 800px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-top: 12px;
          cursor: pointer;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #656e7e;
        }

        .box_1 {
          display: flex;
          margin-top: 25px;
          flex-direction: row;
        }

        .goumBtn {
          cursor: pointer;
          cursor: pointer;

          width: 120px;
          height: 42px;
          border-radius: 0px 0px 0px 0px;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
          line-height: 42px;
          text-align: center;
        }
      }

      .hot {
        position: absolute;
        top: -1px;
        right: -1px;
        width: 64px;
        height: 64px;
        padding: 10px 5px 35px 31px;
        background: linear-gradient(220deg, #ff6632, #ff6632 45%, transparent 46%, transparent 100%);
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-size: 14px;
        color: #ffffff;
        font-weight: bold;
        border-radius: 0 10px 0 0;
      }
    }

    .courseInto {
      padding: 50px 30px 40px 30px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 39%;
        }
      }
    }
    .contents {
      padding: 50px 30px 40px 30px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox1 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 41%;
        }
      }
    }

    .tearchInfo {
      padding: 50px 70px 40px 70px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox2 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 37%;
        }
      }
    }

    .analysis {
      padding: 50px 70px 40px 70px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox2 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 38%;
        }
      }
    }

    .advantages {
      padding: 50px 185px 40px 185px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox2 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 40%;
        }
      }
    }

    .evaluation {
      padding: 50px 59px 46px 50px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox2 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 38%;
        }
      }
    }

    .guide {
      padding: 50px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox2 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 43%;
        }
      }
    }
  }
}

.text_4 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}

.croBox {
  width: 660px;
  height: auto;

  background: #f6f9fc;
  border-radius: 10px 10px 10px 10px;
  padding: 20px;

  .content1 {
    font-weight: 400;
    font-size: 14px;
    color: #444444;
    line-height: 20px;
    margin-top: 10px;
  }
}

.section_1 {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .box_2 {
    width: 280px;
    background: #ffffff;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #f3f3f3;
  }

  .text_5 {
    width: 280px;
    height: 48px;
    background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
    border-radius: 10px 10px 0px 0px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 48px;
    text-align: center;
  }

  .text_6 {
    padding: 16px 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    height: 250px;
    height: 250px;
    color: #656e7e;
    line-height: 19px;
  }
}

.tearchInfo {
  .tearch_1 {
    margin-top: 47px;

    .te_info {
      margin-top: 20px;
      width: 865px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #444444;
      line-height: 22px;
    }

    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/11/ahsjxjy-New-WebApi_1744354225747.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 1260px;
    height: 300px;
    padding: 15px 110px 15px 30px;
    border-radius: 6px 6px 6px 6px;

    .te_name {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
    }

    .present {
      display: flex;
      margin-top: 12px;

      .present_1 {
        // width: 110px;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: linear-gradient(97deg, #95b5ff 0%, #4093f6 100%);
        border-radius: 15px 15px 15px 15px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        margin-right: 10px;
      }

      .present_2 {
        width: 110px;
        height: 30px;
        background: linear-gradient(97deg, #95b5ff 0%, #4093f6 100%);
        border-radius: 15px 15px 15px 15px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 30px;
        text-align: center;
      }
    }
  }
}

.buy_1 {
  margin-top: 30px;

  .buy_btn {
    width: 100px;
    height: 32px;
    background: linear-gradient(97deg, #95b5ff 0%, #4093f6 100%);
    border-radius: 19px 19px 19px 19px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
  }

  .buy_info {
    margin-top: 18px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 23px;
  }
}

.student {
  margin-top: 47px;
  width: 1290px;
  border-bottom: 1px solid #f3f3f3;

  .evaluate {
    width: 1300px;
    height: auto;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #444444;
    line-height: 18px;
    margin-bottom: 24px;
  }

  .avater {
    display: flex;
    margin-bottom: 12px;

    img {
      width: 44px;
      height: 44px;
      border-radius: 44px;
      margin-right: 12px;
    }
  }

  .time_1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
  }

  .stu_name {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;

    .phone {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      margin-top: 2px;
      color: #999999;
    }
  }
}

.adva_1 {
  position: relative;
  display: flex;
  width: 500px;

  .adva_2 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/11/ahsjxjy-New-WebApi_17443543811707.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_12 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/18/ahsjxjy-New-WebApi_1744966526213.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_3 {
    width: 428px;
    height: 58px;
    background: rgba(66, 148, 246, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    text-align: center;
  }

  .adva_13 {
    width: 428px;
    height: 58px;
    background: rgba(240, 169, 59, 0.1);
    background: rgba(240, 169, 59, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    padding-left: 64px;
  }
}

.adva_4 {
  position: relative;
  display: flex;
  width: 500px;

  .adva_5 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/11/ahsjxjy-New-WebApi_1744354324068.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_6 {
    width: 428px;
    height: 58px;
    background: rgba(248, 132, 65, 0.1);
    background: rgba(248, 132, 65, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    text-align: center;
  }

  .adva_15 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/18/ahsjxjy-New-WebApi_1744966458782.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_16 {
    width: 428px;
    height: 58px;
    background: rgba(86, 187, 147, 0.1);
    background: rgba(86, 187, 147, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    padding-left: 64px;
  }
}

.adva_7 {
  position: relative;
  display: flex;
  width: 500px;

  .adva_8 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/11/ahsjxjy-New-WebApi_1744354358139.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_18 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/18/ahsjxjy-New-WebApi_1744966496183.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_9 {
    width: 428px;
    height: 58px;
    background: rgba(234, 87, 89, 0.1);
    background: rgba(234, 87, 89, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    text-align: center;
  }

  .adva_19 {
    width: 428px;
    height: 58px;
    background: rgba(66, 148, 246, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    padding-left: 64px;
  }
}

.ana_icon {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  display: flex;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    margin-right: 8px;
  }
}

.ana_1 {
  margin-top: 24px;
  width: 400px;
  background: #f2f5f8;
  border-radius: 6px 6px 6px 6px;
  padding: 25px 30px;

  .ana_text {
    margin-top: 11px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #656e7e;
  }
}

.catalog {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 20px 30px;
  justify-content: space-between;
  width: 1340px;
  height: 62px;
  background: #f2f5f8;
  border-radius: 6px 6px 6px 6px;

  .text_10 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #444444;
  }

  .text_11 {
    display: flex;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
  }
}

.catalog_1 {
  width: 1340px;
  padding: 20px 30px;
  background: rgba(64, 118, 246, 0.1);
  border-radius: 6px 6px 6px 6px;

  .text_12 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #4076f6;
  }

  .text_13 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    display: flex;
    align-items: center;
  }
}

.chapter {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .chapter_2 {
    width: 74px;
    cursor: pointer;
    height: 30px;
    background: rgba(64, 118, 246, 0.1);
    border-radius: 15px 15px 15px 15px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #4076f6;
    line-height: 30px;
    text-align: center;
  }

  .text_14 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #444444;
  }

  .text_15 {
    margin-top: 4px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
  }
}
</style>
